import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout/layout";
import Metrics from "../../components/metrics";
import ProtectedRoute from "../../../Auth/components/ProtectedRoute";

const AdminMetricsContainer = () => (
  <ProtectedRoute>
    <main>
    <Helmet title="Metrics" />
    <Layout>
      <Metrics superAdminMetrics={false} />
    </Layout>
    </main>
  </ProtectedRoute>
);

export default AdminMetricsContainer;
